import { render } from "./UrlCheckView.vue?vue&type=template&id=fb8d4f6a"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__